angular.module('shared-components.popup.booking', [
  'shared-components.popup',
  'data.booking',
  'data.employee'
]);